export default "__VITE_ASSET__Dz9AMR7a__"